var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mall-info-row"},[_c('span',{staticClass:"mall-info-row__label"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('span',{staticClass:"mall-info-row__value"},_vm._l((_vm.valueLines),function(line){return _c('span',{key:line,staticClass:"mall-info-row__line"},[_vm._v(_vm._s(line))])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65fb12aa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/new/molecules/MallInfoRow.vue
// module id = null
// module chunks = 